// Module
var code = "<script>let $ctrl</script> <molecule-overlay-modal class=\"molecule-panel-whois\" model=\"$ctrl.showPanel\" cancel-callback=\"$ctrl.resetDomain\" title=\"{{ 'TR_100119-63e7db_TR' | translate }} {{ $ctrl.domainName }}\"> <atom-text class=\"molecule-panel-whois__content\">{{ $ctrl.whoisInformationText }}</atom-text> </molecule-overlay-modal> ";
// Exports
module.exports = code;